import './rotateDevice.css';

export const RotateDevice = () => (
    <div className="rotate-device">
        <div className="rotate-device__icon">
            <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                {/* Phone body — portrait, centered slightly right/down to leave arc room */}
                <rect x="28" y="18" width="24" height="42" rx="5"
                    stroke="currentColor" strokeWidth="2.5" fill="none" />
                {/* Speaker bar */}
                <rect x="34" y="24" width="12" height="2" rx="1" fill="currentColor" opacity={0.5} />
                {/* Home button */}
                <circle cx="40" cy="54" r="2" fill="currentColor" />

                {/*
                  ~340° clockwise arc. Centre (40,39), radius 29.
                  Start (45,10) at θ=280°, end (35,10) at θ=260°.
                  Gap of ~10px sits at the top of the circle.
                  large-arc=1 (>180°), sweep=1 (clockwise in SVG).
                */}
                <path
                    d="M 45 10 A 29 29 0 1 1 35 10"
                    stroke="var(--accent-color)" strokeWidth="2.5"
                    fill="none" strokeLinecap="round"
                />
                {/*
                  Arrowhead at (35,10). Tangent at θ=260° ≈ rightward.
                  Symmetric barbs above/below the tip.
                */}
                <path
                    d="M 29 5 L 35 10 L 29 15"
                    stroke="var(--accent-color)" strokeWidth="2.5"
                    fill="none" strokeLinecap="round" strokeLinejoin="round"
                />
            </svg>
        </div>
        <p className="rotate-device__text">Please rotate your device to portrait mode</p>
    </div>
);
